var PubSub = require("underpub-js");
var turf = require('@turf/turf');

var PoiMap = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

PoiMap.prototype.init = function(){

  var self = this;

  this.initMap();

  this.hideCardScrollBar();

  // on window resize, make sure proper scrollbar is hidden
  PubSub.subscribe("resized", function(){
    self.hideCardScrollBar();
    self.centerMap();
  });

  // when a map marker is clicked
  this.options.$el.find('#map-container').on('click', '.marker', function() {
    console.log('marker clicked');

    // remove active classes from previously active card/marker
    self.options.$el.find('.point-of-interest').removeClass('active');
    self.options.$el.find('#map-container .marker').removeClass('active');

    var markerId = $(this).attr('id');
    var cardId = $(this).data('cardId');
    var markerLat = $(this).data('markerLat');
    var markerLng = $(this).data('markerLng');

    var $relatedCard = self.options.$el.find('#' + cardId);
    var $scrollContainer = self.options.$el.find('.poi-scroll-container');

    var flyToLat = Number(markerLat);
    var flyToLng = Number(markerLng);

    // adjust values because map is slightly off center on large screens
    flyToLat -= .000;
    if (window.Breakpoint.value == "xlarge")
    {
      flyToLng -= .0025;
    }
    else if (window.Breakpoint.value == "large")
    {
      flyToLng -= .0025;
    }

    self.map.flyTo({
      center: [
        flyToLng,
        flyToLat
      ],
      zoom: 16
    });

    // add active class to marker and card
    $(this).addClass('active');
    $relatedCard.addClass('active');

    // scroll poi-scroll-container to show cards
    if ($relatedCard.length) 
    {

      if ((window.Breakpoint.value == "xlarge") || (window.Breakpoint.value == "large"))
      {
        // scroll vertically
        var cardScrollTop = $scrollContainer.scrollTop() + $relatedCard.position().top - ($scrollContainer.height()/2) + ($relatedCard.height()/2);

        $scrollContainer.animate(
          {
            scrollTop: cardScrollTop,
          },
          300,
          'linear'
        );

      }
      else
      {

        // scroll horizontally
        var cardScrollLeft = $scrollContainer.scrollLeft() + $relatedCard.position().left - (($scrollContainer.width() - $relatedCard.width()) / 2);

        $scrollContainer.animate(
          {
            scrollLeft: cardScrollLeft,
          },
          300,
          'linear'
        );

      }

    }

  });

  // when a POI card is clicked
  this.options.$el.find('.poi-outer-container .poi-inner-container').on('click', '.point-of-interest', function() {
    
    // remove active classes from previously active card/marker
    self.options.$el.find('.point-of-interest').removeClass('active');
    self.options.$el.find('#map-container .marker').removeClass('active');

    var $scrollContainer = self.options.$el.find('.poi-scroll-container');

    var flyToLat = Number($(this).data('markerLat'));
    var flyToLng = Number($(this).data('markerLng'));

    // adjust values because map is slightly off center
    flyToLat -= .000;
    if (window.Breakpoint.value == "xlarge")
    {
      flyToLng -= .0025;
    }
    else if (window.Breakpoint.value == "large")
    {
      flyToLng -= .0025;
    }

    self.map.flyTo({
      center: [
        flyToLng,
        flyToLat
      ],
      zoom: 16
    });

    // add active class to marker and card
    $(this).addClass('active');
    self.options.$el.find('#map-container .marker#' + $(this).data('markerId')).addClass('active');

    

    // scroll poi-scroll-container to show card that was clicked
    if ((window.Breakpoint.value == "xlarge") || (window.Breakpoint.value == "large"))
    {
      // scroll vertically
      var cardScrollTop = $scrollContainer.scrollTop() + $(this).position().top - ($scrollContainer.height()/2) + ($(this).height()/2);

      $scrollContainer.animate(
        {
          scrollTop: cardScrollTop,
        },
        300,
        'linear'
      );

    }
    else
    {

      // scroll horizontally
      var cardScrollLeft = $scrollContainer.scrollLeft() + $(this).position().left - (($scrollContainer.width() - $(this).width()) / 2);

      $scrollContainer.animate(
        {
          scrollLeft: cardScrollLeft,
        },
        300,
        'linear'
      );

    }

    

  });

};

PoiMap.prototype.hideCardScrollBar = function() {
  
  var $poiScrollContainer = this.options.$el.find('.poi-scroll-container');
  var $poiOuterContainer = this.options.$el.find('.poi-outer-container');

  // reset
  $poiOuterContainer.css('height', 'auto');
  $poiScrollContainer.css('padding-right', '0px');

  if ((window.Breakpoint.value == "xlarge") || (window.Breakpoint.value == "large"))
  {

    // remove vertical scroll bar from poi-inner-container
    var containerPaddingRight = $poiScrollContainer[0].offsetWidth - $poiScrollContainer[0].clientWidth + 'px';
    $poiScrollContainer.css('padding-right', containerPaddingRight);

  }
  else
  {

    // remove horizontal scroll bar
    var containerHeightAdjustment = $poiScrollContainer[0].offsetHeight - $poiScrollContainer[0].clientHeight;

    var outerContainerHeight = $poiOuterContainer.height();

    var newOuterContainerHeight = Number(outerContainerHeight) - Number(containerHeightAdjustment);

    $poiOuterContainer.css('height', newOuterContainerHeight);

  }

};

PoiMap.prototype.initMap = function(){

  var self = this;

  mapboxgl.accessToken = 'pk.eyJ1IjoiYXV0aGVudGljZmYiLCJhIjoiY2ppYmt1d2I4MWdsMTNxcDBpY2FoY3hveSJ9.t_E3qC1Z5bKMoCW3y4XkdQ';

  // get our geoJson
  var componentId = this.options.$el.data('componentId');
  this.geoJson = window[componentId];

  var dragPanSetting = true;
  if (window.screen.width <= 768)
  {
    dragPanSetting = false;
  }

  this.map = new mapboxgl.Map({
    container: self.options.$el.find('#map-container')[0],
    style: 'mapbox://styles/authenticff/ck0wyjx6xdq161cqrxz256oim',
    dragPan: dragPanSetting
  });

  // disable scroll to zoom
  this.map.scrollZoom.disable();

  // fix for map size on load
  this.map.resize();

  this.map.addControl(new mapboxgl.NavigationControl());

  this.addPOIs();

  this.bbox = turf.bbox({
    type: 'FeatureCollection',
    features: self.geoJson.features
  });

  this.centerMap();
};

PoiMap.prototype.centerMap = function() {

  var self = this;

  // get map padding based on window size
  var paddingArray;
  if (window.Breakpoint.value == "xlarge") {
    paddingArray = {top: 100, bottom: 100, left: 640, right: 100};
  }
  else if (window.Breakpoint.value == "large") {
    paddingArray = {top: 100, bottom: 100, left: 564, right: 100};
  }
  else {
    paddingArray = {top: 100, bottom: 100, left: 100, right: 100};
  }

  // zoom map to bounding box
  this.map.fitBounds(self.bbox, {
    padding: paddingArray
  });

};

PoiMap.prototype.addPOIs = function() {

  var self = this;

  // add points of interest to map

  var pointIndex = 0;

  // for each marker
  this.geoJson.features.forEach(function(marker) {

    // create a DOM element for the marker
    var el = document.createElement('div');
    el.className = 'marker';
    el.id = marker.properties.markerId;

    // add our data information
    el.dataset.markerLng = marker.geometry.coordinates[0];
    el.dataset.markerLat = marker.geometry.coordinates[1];
    el.dataset.cardId = marker.properties.cardId;

    if (marker.properties.mainProperty)
    {
      el.className = 'marker main-property';
    }


    // this is a modified version of our SVG replacement script
    // it goes through the markers, and inlines any SVG icons
    if (marker.properties.icon.match(/.*\.svg/))
    {

      $.ajax({
          url: marker.properties.icon,
          dataType: 'xml',
          success: function(data) {

              var $wrapperDiv = $('<div class="inline-svg-wrapper"></div>');
              
              // Get the SVG tag, ignore the rest
              var $svg = $(data).find('svg');

              // IE doesn't scale SVG properly so we need to use a canvas object
              if($svg.attr('height') && $svg.attr('width')) {
                  var $canvas = $('<canvas class="svg-frame" height="' + $svg.attr('height') + '" width="' + $svg.attr('width') + '"></canvas>');
              }
              else {
                  var $canvas = $('<canvas class="svg-frame" height="1" width="1"></canvas>');
              }

              $wrapperDiv.append($canvas);

              // Add replaced image's ID to the new SVG
              if(typeof imgID !== 'undefined') {
                  $svg = $svg.attr('id', imgID);
              }

              // Add replaced image's classes to the new SVG
              if(typeof imgClass !== 'undefined') {
                  $svg = $svg.attr('class', imgClass + ' replaced-svg');
              }

              // Remove any invalid XML tags as per http://validator.w3.org
              $svg = $svg.removeAttr('xmlns:a');

              // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
              if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                  $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
              }

              // do not include height and width attributes on svg
              $svg.removeAttr('height');
              $svg.removeAttr('width');

              $wrapperDiv.append($svg);

              // insert $wrapperDiv into our marker element
              el.appendChild($wrapperDiv[0])

          }
      });

    }
    else
    {
      // if not an SVG, just ise regular image element
      var imgEl = document.createElement('img');
      imgEl.src = marker.properties.icon;

      el.appendChild(imgEl)
    }

    // add marker to map
    new mapboxgl.Marker(el)
      .setLngLat(marker.geometry.coordinates)
      .addTo(self.map);

    pointIndex++;

  });

};

module.exports = PoiMap;
